import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";

import img1 from "../assets/galleryassests/8.jpg";
import main from "../assets/petsafety/1.jpg";
import img2 from "../assets/petsafety/2.jpg";
import img3 from "../assets/petsafety/3.jpg";

import { Helmet } from "react-helmet-async";

import Images from "./Images";

export default function PetsSafetyNets() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Pets Safety Nets in Bengaluru - ANS Safety Nets",
    url: "https://www.anssafetynets.com/petssafetynets",
    description:
      "Ensure the safety of your pets with high-quality Pets Safety Nets by ANS Safety Nets in Bengaluru. Perfect solutions for balconies, windows, and gardens to protect your furry friends.",
    keywords: [
      "ANS Safety Nets",
      "Pets Safety Nets",
      "Safety Nets in Bengaluru",
      "Pet Safety Solutions",
      "Pet Nets by ANS Safety Nets",
      "safety nets in bengaluru",
      "ans safety nets",
      "Ans Safety Nets bengaluru",
      "Safety Nets in Bengaluru",
      "Safety Solutions",
      "Bengaluru Safety Nets",
      "balcony safety nets in bengaluru",
      "balcony safety nets",
      "pigeon safety nets in bengaluru",
      "monkey safety nets in bengaluru",
      "Ducteria Nets in bengaluru",
      "Pets Safety Nets in bengaluru",
      "Industrial Safety Nets in bengaluru",
      "Children Safety Nets in bengaluru",
      "Bird Spikes in Bengaluru",
      "Cricket Practice Nets in bengaluru",
      "Sports Nets",
      "Pigeon Safety Nets",
      "Building covering Net",
      "sports nets in bengaluru",
      "building covering nets in bengaluru",
    ],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Pets Safety Nets",
          item: "https://www.anssafetynets.com/petssafetynets",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Pets Safety Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };
  return (
    <div>
      <Helmet>
        <title>Pets Safety Nets in Bengaluru - ANS Safety Nets</title>
        <meta
          name="description"
          content="Ensure the safety of your pets with high-quality Pets Safety Nets by ANS Safety Nets in Bengaluru. Perfect solutions for balconies, windows, and gardens to protect your furry friends."
        />
        <meta
          name="keywords"
          content="ANS Safety Nets, Pets Safety Nets, Safety Nets in Bengaluru, Pet Safety Solutions, Pet Nets by ANS Safety Nets,safety nets in bengaluru , ans safety nets ,Ans Safety Nets bengaluru, Safety Nets in Bengaluru, ANS Safety Nets, safety nets in bengaluru, Safety Solutions, Bengaluru Safety Nets , balcony safety nets in bengaluru , balcony safety nets,pegion safety nets in bengaluru, monkey safety nets in bengaluru,Ducteria Nets in bengaluru, Pets Safety Nets in bengaluru, Industrial Safety Nets in bengaluru, Children Safety Nets in bengaluru, Bird Spikes in , Cricket Practice Nets in bengaluru,Sports Nets,Pigeon Safety Nets,Building covering Net,pigeon Safety Nets, Sports Nets in bengaluru,Pigeon Safety Nets in bengaluru,Building covering Net in bengaluru,pigeon Safety Nets in bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/petssafetynets"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <HeroSection
        title="Pets Safety Nets"
        description="Ensure your pets' safety with our strong and reliable safety nets."
        bgColor="bg-[#2c3639]"
        image="https://example.com/pets-safety-nets.jpg"
      />

      <ProductDetails
        title="Why Choose Our Pets Safety Nets?"
        content="At ANS Safety Nets, we understand how important it is to keep your pets safe and secure. Our pet safety nets are designed to offer peace of mind by preventing your furry friends from falling or escaping from high places such as balconies, windows, or terraces. Crafted from strong, weather-resistant materials, our nets provide reliable protection while allowing your pets to enjoy the outdoors safely. Customizable to fit various spaces, our pet safety nets ensure that your pets are safe from potential accidents, allowing them to roam freely without the risk of harm. With ANS Safety Nets, you can rest assured knowing your pets are protected, giving them a safe space to play and explore."
        image={main}
      />
      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Pet Protection",
            description:
              "Keep your pets safe and secure on balconies, windows, and more.",
          },
          {
            title: "UV Resistant",
            description:
              "Our nets are UV resistant and designed for outdoor use.",
          },
          {
            title: "Durable and Strong",
            description:
              "Made from high-strength materials to withstand the toughest conditions.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "Will the nets prevent my pet from escaping?",
            answer:
              "Yes, the nets are designed to keep pets safely inside the area.",
          },
          {
            question: "Are the nets easy to clean?",
            answer: "Yes, the nets are easy to clean and maintain.",
          },
        ]}
      />
    </div>
  );
}
